import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Typography, CircularProgress, Button, Alert } from '@mui/material';

const GoogleOAuthCallback = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [status, setStatus] = useState('processing');

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const code = params.get('code');
        const authToken = params.get('auth_token');

        if (code && window.opener) {
            // If opened as popup, send message back with auth token
            window.opener.postMessage({
                type: 'GOOGLE_OAUTH_CALLBACK',
                code,
                authToken
            }, window.location.origin);
            setStatus('success');
        } else {
            setStatus('error');
        }
    }, [location]);

    const handleClose = () => {
        if (window.opener) {
            window.close();
        } else {
            navigate('/admin/email-settings');
        }
    };

    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            minHeight="100vh"
            gap={2}
            p={3}
        >
            {status === 'processing' && (
                <>
                    <CircularProgress />
                    <Typography variant="h6">Processing OAuth callback...</Typography>
                </>
            )}
            {status === 'success' && (
                <>
                    <Alert severity="success">OAuth setup completed successfully!</Alert>
                    <Typography variant="body1" align="center" sx={{ mt: 2 }}>
                        You can close this window and return to the email settings page.
                    </Typography>
                    <Button variant="contained" onClick={handleClose} sx={{ mt: 2 }}>
                        {window.opener ? 'Close Window' : 'Return to Settings'}
                    </Button>
                </>
            )}
            {status === 'error' && (
                <>
                    <Alert severity="error">Failed to complete OAuth setup.</Alert>
                    <Typography variant="body1" align="center" sx={{ mt: 2 }}>
                        Please try again or contact support if the issue persists.
                    </Typography>
                    <Button variant="contained" onClick={handleClose} sx={{ mt: 2 }}>
                        Return to Settings
                    </Button>
                </>
            )}
        </Box>
    );
};

export default GoogleOAuthCallback; 